<template>
  <div class="d-flex align-center my-2">
    <v-textarea
      hide-details
      outlined
      auto-grow
      clearable
      dense
      @keydown.enter.prevent="submit"
      :label="$t('journal.search.criterias.semantic.input')"
      rows="1"
      v-model="text"
      class="text-prompt-area"
      :rules="rules"
    />
    <v-text-field
      @keydown.enter.prevent="submit"
      :label="$t('journal.search.criterias.score')"
      class="ml-2"
      style="width: 150px; max-width: 150px;"
      hide-details
      dense
      outlined
      type="number"
      v-model="multiplier"
      :rules="rules"
    />
  </div>
</template>
<script>
import { nanoid } from 'nanoid';
import { PromptType } from '../SearchUtils';
import { criterias } from '../SearchCriteria';

export default {
  name: 'SemanticSearch',
  props: {
    params: {
      type: Object,
      default: undefined,
    },
    currentSearchDetails: {
      type: Object,
      default: undefined,
    },
  },
  data: () => ({
    multiplier: 1.0,
    text: '',
    id: `${criterias.SEMANTIC_SEARCH}/${nanoid(10)}`,
    rules: [
      v => !!v || 'Ce champs ne peut être vide',
    ],
  }),
  created() {
    if (this.params !== undefined) {
      const data = this.params.scorings[0].Semantic;
      this.id = data.id;
      this.text = data.param;
      this.multiplier = Number.parseFloat(data.multiplier);
    }
  },
  methods: {
    submit() {
      this.$emit('submit');
    },
    getCriteria() {
      const scorings = [
        {
          [PromptType.SEMANTIC]: {
            param: this.text,
            id: this.id,
            multiplier: Number.parseFloat(this.multiplier),
          },
        },
      ];

      return { scorings, filters: [] };
    },
    populateCriteria(params) {
      const { param, multiplier, id } = params.scoring;
      this.param = param;
      this.multiplier = multiplier;
      this.id = id;
    },
  },
};
</script>
